module.exports = __webpack_public_path__ + "img/action-collect-hover.9bffa4b2.svg";